import type { Pregunta, Respuesta } from '@pasos/schemas';
import { PACIENTE } from '../copy/index.js';
import type { CatalogosDescargados } from './catalogos.js';
import { nombreDeLoElegido } from './preguntas/Catalogo.js';
import { formatearFecha } from './preguntas/Fecha.js';
import { formatearNumero } from './preguntas/Numero.js';

/**
 * Cómo se lee una respuesta en el eco del check-in ("Tu respuesta: …").
 *
 * Es **la etiqueta que el paciente acaba de tocar**, tal como la dice el
 * instrumento —el número de la escala, "Sí" o "No", el texto de la opción—, sin
 * interpretarla. Viene del campo de la pregunta, en `@pasos/schemas`: acá no se
 * redacta nada.
 *
 * Los tipos de E3.25 se leen igual de literal: la cantidad con su unidad ("2,5
 * mg"), la fecha en palabras, la droga con su presentación y, en un grupo,
 * cuántas filas quedaron en la lista.
 */
export function textoDeRespuesta(
  pregunta: Pregunta,
  valor: Respuesta,
  catalogos: CatalogosDescargados = {},
): string {
  const { campo } = pregunta;

  switch (campo.tipo) {
    case 'binario':
      return valor === true ? campo.etiquetaSi : campo.etiquetaNo;
    case 'opcion':
      return campo.opciones.find((opcion) => opcion.codigo === valor)?.etiqueta ?? String(valor);
    case 'numero':
      return `${formatearNumero(Number(valor))} ${campo.unidad.etiqueta}`;
    case 'fecha':
      return formatearFecha(String(valor));
    case 'catalogo':
      return nombreDeLoElegido(campo, String(valor), catalogos[campo.catalogo] ?? []);
    case 'grupo':
      return PACIENTE.formulario.enLaLista(Array.isArray(valor) ? valor.length : 0);
    default:
      return String(valor);
  }
}
